import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@jetbrains/ring-ui/components/button/button';
import Icon from '@jetbrains/ring-ui/components/icon';
import moreOptionsIcon from '@jetbrains/icons/more-options';
import classnames from 'classnames';
import styles from './edit-profile-button.css';
export function EditProfileButton({ className, ...props }) {
    return (_jsx(Button, { className: classnames(styles.editButton, className), ...props, children: _jsx(Icon, { className: styles.editIcon, glyph: moreOptionsIcon }) }));
}
